import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

// sibling to the #root element on the actual html dom
const loaderRoot = document.getElementById('loader-portal');

class LoaderPortal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    loaderRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    loaderRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

LoaderPortal.propTypes = {
  children: PropTypes.node,
};

export {
  LoaderPortal,
};
